export interface FieldErrorMap {
  message?: string | null;
  buttons?: string | null;
  image?: string | null;
  recipients?: string | null;
  template_id?: string | null;
}

export function mapErrors(errors: Record<string,string>): FieldErrorMap {
  return {
    message: errors.message || null,
    buttons: errors.buttons || (errors['buttons[0]'] ? '버튼 오류' : null),
    image: errors.image || null,
    recipients: errors.recipientsCount || errors.recipients || null,
    template_id: errors.template_id || null,
  };
}
